module.exports = __webpack_public_path__ + "img/front-dark.ab271af1.png";